/**
 * This module provides validation functionality for checking the integrity
 * of action links within a runbook's action tree structure.
 */

/**
 * Validates all action links within the action tree to ensure there are no stale UIDs
 * @returns {Object} Validation results containing status and any issues found
 */
export const validateActionLinks = function() {
    const allActionUids = Object.keys(this.actionsMap);
    const issuesFound = [];

    for (const uid of allActionUids) {
        const action = this.actionsMap[uid];

        if (!action) {
            issuesFound.push(`Attempted to validate action UID ${uid} but it was not found in actionsMap.`);
            continue;
        }

        if (action.treeParent !== null && !this.actionsMap[action.treeParent]) {
            issuesFound.push(`Action UID ${uid} (Name: "${action.name}") has stale treeParent UID: ${action.treeParent}`);
        }

        if (action.prevSibling !== null && !this.actionsMap[action.prevSibling]) {
            issuesFound.push(`Action UID ${uid} (Name: "${action.name}") has stale prevSibling UID: ${action.prevSibling}`);
        }

        if (action.nextSibling !== null && !this.actionsMap[action.nextSibling]) {
            issuesFound.push(`Action UID ${uid} (Name: "${action.name}") has stale nextSibling UID: ${action.nextSibling}`);
        }

        if (action.children && Array.isArray(action.children)) {
            for (const childUid of action.children) {
                if (!this.actionsMap[childUid]) {
                    issuesFound.push(`Action UID ${uid} (Name: "${action.name}") has stale child UID in 'children' array: ${childUid}`);
                }
            }
        }

        if (action.treeChildren && Array.isArray(action.treeChildren)) {
            for (const treeChildUid of action.treeChildren) {
                if (!this.actionsMap[treeChildUid]) {
                    issuesFound.push(`Action UID ${uid} (Name: "${action.name}") has stale child UID in 'treeChildren' array: ${treeChildUid}`);
                }
            }
        }
    }

    return {
        issuesFound,
        status: issuesFound.length === 0 ? 'PASSED' : 'FAILED'
    };
}
